const CUSTOMLOG_RESET = 'CUSTOMLOG_RESET';
const LOG_CUSTOM_ATTRIBUTE = 'LOG_CUSTOM_ATTRIBUTE';
const LOG_CUSTOM_EVENT = 'LOG_CUSTOM_EVENT';
const SINGLE_LOG_CUSTOM_ATTRIBUTE = 'SINGLE_LOG_CUSTOM_ATTRIBUTE';
const SINGLE_LOG_CUSTOM_EVENT = 'SINGLE_LOG_CUSTOM_EVENT';
const MODAL_SLIDE_UP_CUSTOM_ATTRIBUTE = 'MODAL_SLIDE_UP_CUSTOM_ATTRIBUTE';
const MODAL_SLIDE_UP_CUSTOM_EVENT = 'MODAL_SLIDE_UP_CUSTOM_EVENT';
const MODAL_SLIDE_UP_IMGS_CUSTOM_ATTRIBUTE = 'MODAL_SLIDE_UP_IMGS_CUSTOM_ATTRIBUTE';
const MODAL_SLIDE_UP_IMGS_CUSTOM_EVENT = 'MODAL_SLIDE_UP_IMGS_CUSTOM_EVENT';
const FULL_COUNTDOWN_CUSTOM_ATTRIBUTE = 'FULL_COUNTDOWN_CUSTOM_ATTRIBUTE';
const FULL_COUNTDOWN_CUSTOM_EVENT = 'FULL_COUNTDOWN_CUSTOM_EVENT';
const HALF_TOP_IMAGE_CUSTOM_ATTRIBUTE = 'HALF_TOP_IMAGE_CUSTOM_ATTRIBUTE';
const HALF_TOP_IMAGE_CUSTOM_EVENT = 'HALF_TOP_IMAGE_CUSTOM_EVENT';
const FULL_DUAL_IMAGE_CUSTOM_ATTRIBUTE = 'FULL_DUAL_IMAGE_CUSTOM_ATTRIBUTE';
const FULL_DUAL_IMAGE_CUSTOM_EVENT = 'FULL_DUAL_IMAGE_CUSTOM_EVENT';
const FULL_SURVEY_CUSTOM_ATTRIBUTE = 'FULL_SURVEY_CUSTOM_ATTRIBUTE';
const FULL_SURVEY_CUSTOM_EVENT = 'FULL_SURVEY_CUSTOM_EVENT';
const MODAL_SLIDE_IMAGE_CUSTOM_ATTRIBUTE = 'MODAL_SLIDE_IMAGE_CUSTOM_ATTRIBUTE';
const MODAL_SLIDE_IMAGE_CUSTOM_EVENT = 'MODAL_SLIDE_IMAGE_CUSTOM_EVENT';

export const customlogReset = () => ({ type: CUSTOMLOG_RESET});
export const logCustomAttribute = (logCustomAttribute: string[]) => ({
  type: LOG_CUSTOM_ATTRIBUTE,
  logCustomAttribute
});
export const logCustomEvent = (logCustomEvent: string[]) => ({
  type: LOG_CUSTOM_EVENT,
  logCustomEvent
});
export const singleLogCustomAttribute = (singleLogCustomAttribute: string) => ({
  type: SINGLE_LOG_CUSTOM_ATTRIBUTE,
  singleLogCustomAttribute
});
export const singleLogCustomEvent = (singleLogCustomEvent: string) => ({
  type: SINGLE_LOG_CUSTOM_EVENT,
  singleLogCustomEvent
});
export const modalSlideUpCustomAtrribute = (modalSlideUpCustomAtrribute: string) => ({
  type: MODAL_SLIDE_UP_CUSTOM_ATTRIBUTE,
  modalSlideUpCustomAtrribute
});
export const modalSlideUpCustomEvent = (modalSlideUpCustomEvent: string) => ({
  type: MODAL_SLIDE_UP_CUSTOM_EVENT,
  modalSlideUpCustomEvent
});
export const modalSlideUpImgsCustomAtrribute = (modalSlideUpImgsCustomAtrribute: string[]) => ({
  type: MODAL_SLIDE_UP_IMGS_CUSTOM_ATTRIBUTE,
  modalSlideUpImgsCustomAtrribute
});
export const modalSlideUpImgsCustomEvent = (modalSlideUpImgsCustomEvent: string[]) => ({
  type: MODAL_SLIDE_UP_IMGS_CUSTOM_EVENT,
  modalSlideUpImgsCustomEvent
});
export const fullCountdownCustomAttribute = (fullCountdownCustomAttribute: string) =>({
  type: FULL_COUNTDOWN_CUSTOM_ATTRIBUTE,
  fullCountdownCustomAttribute
});
export const fullCountdownCustomEvent = (fullCountdownCustomEvent: string) => ({
  type: FULL_COUNTDOWN_CUSTOM_EVENT,
  fullCountdownCustomEvent
});
export const halfTopImageCustomAttribute = (halfTopImageCustomAttribute: string[]) => ({
  type: HALF_TOP_IMAGE_CUSTOM_ATTRIBUTE,
  halfTopImageCustomAttribute
});
export const halfTopImageCustomEvent = (halfTopImageCustomEvent: string[]) =>({
  type: HALF_TOP_IMAGE_CUSTOM_EVENT,
  halfTopImageCustomEvent
});
export const fullDualImageCustomAttribute = (fullDualImageCustomAttribute: string) => ({
  type: FULL_DUAL_IMAGE_CUSTOM_ATTRIBUTE,
  fullDualImageCustomAttribute
});
export const fullDualImageCustomEvent = (fullDualImageCustomEvent: string) => ({
  type: FULL_DUAL_IMAGE_CUSTOM_EVENT,
  fullDualImageCustomEvent
});
export const fullSurveyCustomAttribute = (fullSurveyCustomAttribute: string) => ({
  type: FULL_SURVEY_CUSTOM_ATTRIBUTE,
  fullSurveyCustomAttribute
});
export const fullSurveyCustomEvent = (fullSurveyCustomEvent: string) => ({
  type: FULL_SURVEY_CUSTOM_EVENT,
  fullSurveyCustomEvent
});
export const modalSlideImageCustomAttribute = (modalSlideImageCustomAttribute: string) => ({
  type: MODAL_SLIDE_IMAGE_CUSTOM_ATTRIBUTE,
  modalSlideImageCustomAttribute
});
export const modalSlideImageCustomEvent = (modalSlideImageCustomEvent: string) => ({
  type: MODAL_SLIDE_IMAGE_CUSTOM_EVENT,
  modalSlideImageCustomEvent
});

const initialState = {
  logCustomAttribute: ['', '', ''],
  logCustomEvent: ['','',''],
  singleLogCustomAttribute: '',
  singleLogCustomEvent: '',
  modalSlideUpCustomAtrribute: '',
  modalSlideUpCustomEvent: '',
  modalSlideUpImgsCustomAtrribute: ['', '', ''],
  modalSlideUpImgsCustomEvent: ['', '', ''],
  fullCountdownCustomAttribute: '',
  fullCountdownCustomEvent: '',
  halfTopImageCustomAttribute: ['', '', ''],
  halfTopImageCustomEvent: ['', '', ''],
  fullDualImageCustomAttribute: '',
  fullDualImageCustomEvent: '',
  fullSurveyCustomAttribute: '',
  fullSurveyCustomEvent: '',
  modalSlideImageCustomAttribute: '',
  modalSlideImageCustomEvent : '',
}

export default function customlogReducer(state = initialState, action) {
  switch(action.type) {
    case CUSTOMLOG_RESET:
      return initialState;
    case LOG_CUSTOM_ATTRIBUTE:
      return {
        ...state,
        logCustomAttribute: action.logCustomAttribute
      }
    case LOG_CUSTOM_EVENT:
      return {
        ...state,
        logCustomEvent: action.logCustomEvent
      }
    case SINGLE_LOG_CUSTOM_ATTRIBUTE:
      return {
        ...state,
        singleLogCustomAttribute: action.singleLogCustomAttribute
      }
    case SINGLE_LOG_CUSTOM_EVENT:
      return {
        ...state,
        singleLogCustomEvent: action.singleLogCustomEvent
      }
    case MODAL_SLIDE_UP_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        modalSlideUpCustomAtrribute: action.modalSlideUpCustomAtrribute
      }
    case MODAL_SLIDE_UP_CUSTOM_EVENT:
    return{
      ...state,
      modalSlideUpCustomEvent: action.modalSlideUpCustomEvent
    }
    case MODAL_SLIDE_UP_IMGS_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        modalSlideUpImgsCustomAtrribute: action.modalSlideUpImgsCustomAtrribute
      }
    case MODAL_SLIDE_UP_IMGS_CUSTOM_EVENT:
    return{
      ...state,
      modalSlideUpImgsCustomEvent: action.modalSlideUpImgsCustomEvent
    }
    case FULL_COUNTDOWN_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        fullCountdownCustomAttribute: action.fullCountdownCustomAttribute
      }
    case FULL_COUNTDOWN_CUSTOM_EVENT:
      return{
        ...state,
        fullCountdownCustomEvent: action.fullCountdownCustomEvent
      }
    case HALF_TOP_IMAGE_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        halfTopImageCustomAttribute: action.halfTopImageCustomAttribute
      }
    case HALF_TOP_IMAGE_CUSTOM_EVENT:
      return{
        ...state,
        halfTopImageCustomEvent: action.halfTopImageCustomEvent
      }
    case FULL_DUAL_IMAGE_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        fullDualImageCustomAttribute: action.fullDualImageCustomAttribute
      }
    case FULL_DUAL_IMAGE_CUSTOM_EVENT:
      return{
        ...state,
        fullDualImageCustomEvent: action.fullDualImageCustomEvent
      }
    case FULL_SURVEY_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        fullSurveyCustomAttribute: action.fullSurveyCustomAttribute
      }
    case FULL_SURVEY_CUSTOM_EVENT:
      return{
        ...state,
        fullSurveyCustomEvent: action.fullSurveyCustomEvent
      }
    case MODAL_SLIDE_IMAGE_CUSTOM_ATTRIBUTE:
      return{
        ...state,
        modalSlideImageCustomAttribute: action.modalSlideImageCustomAttribute
      }
    case MODAL_SLIDE_IMAGE_CUSTOM_EVENT:
      return{
        ...state,
        modalSlideImageCustomEvent: action.modalSlideImageCustomEvent
      }
    default:
      return state;
  }
}